export default __webpack_public_path__ + "static/media/kia-car-icon.08ff2b7e.png";